export default __webpack_public_path__ + "static/media/star-fill-gray5-48.1b6f8e8b.svg";